// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1lNa1","detailsBorder":"styles_detailsBorder__7ibwd"};